import { Col, Row } from "antd";
import styles from "./ProfileUploadDocument.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { useNavigate } from "react-router-dom";
import addDoc from "../../../../assets/staticImages/addDoc.png";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { memo, useRef, useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const RenderDoc = memo(({ docs, i }) => {
  return (
    <DocViewer
      documents={
        docs?.id
          ? [
              {
                uri: `https://www.bestdayever.me/api/downloadFile?path=${docs.doc}`,
              },
            ]
          : [docs]
      }
      pluginRenderers={DocViewerRenderers}
      className={styles.pdfView}
      config={{
        header: { disableHeader: true },
        pdfVerticalScrollByDefault: false,
      }}
      language="en"
    />
  );
});

const RenderDocView = memo(({ docs, setDocs, i, doc }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }
  const deleteDoc = (i) => {
    let docCopy = [...docs];
    docCopy.splice(i, 1);
    setDocs(docCopy);
    // console.log("iddddddddddddddddddd", id);
    // const arr = docs.filter((data) => {
    //   console.log(id != data.id);
    //   if (id != data.id) {
    //     return data;
    //   }
    // });
    // setDocs(arr);
    setDropdownOpen(false);
  };

  return (
    <Col className={styles.pdfCol} key={i.toString()}>
      <Row style={{ justifyContent: "flex-end" }}>
        <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
          ...
        </TextComponent>
      </Row>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Col>
            <Row className={styles.dropdownItem} onClick={() => deleteDoc(i)}>
              <RiDeleteBinLine fontSize="1.1rem" />
              <TextComponent textClass={styles.dropdownText}>
                Delete
              </TextComponent>
            </Row>
          </Col>
        </Row>
      )}
      <RenderDoc docs={doc} i={i} />
    </Col>
  );
});

const ProfileUploadDocument = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [docs, setDocs] = useState([...user?.documents]);
  const docRef = useRef();
  console.log("docsssssssss//////////////", docs);

  const handleClick = () => {
    docRef.current.value = "";
    docRef.current.click();
  };
  const upload = () => {
    // if (docs.length > 0) {
      dispatch(AuthMiddleware.updateVendorProfile({ documents: docs }))
        .then(() => navigate(-1))
        .catch();
    // } else {
    //   dispatch(
    //     showAlert({ message: "Please upload document first.!", status: 400 })
    //   );
    // }
  };
  return (
    <>
      <Row>
        <TextComponent textClass={styles.heading}>Gallery</TextComponent>
      </Row>
      <Row gutter={[16, 16]} className={styles.documentRow}>
        {docs.map((doc, i) => {
          return (
            <Col xs={24} md={12} xl={8}>
              <RenderDocView docs={docs} doc={doc} i={i} setDocs={setDocs} />
            </Col>
          );
        })}
        <Col
          xs={24}
          md={12}
          xl={8}
          className={styles.imgCol}
          onClick={handleClick}
        >
          <img src={addDoc} className={styles.image} alt="docSelect" />
          <input
            type="file"
            accept=".pdf"
            multiple
            onChange={(el) =>
              el.target.files?.length &&
              setDocs([
                ...docs,
                ...Array.from(el.target.files).map((file, i) => ({
                  doc: file,
                  uri: window.URL.createObjectURL(file),
                  fileName: file.name,
                  // id: `${docs?.length + i + 12}`,
                })),
              ])
            }
            ref={docRef}
            className={styles.displayNone}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={12} xl={8}>
          <SubmitButton title="Save" onClick={upload} />
        </Col>
      </Row>
    </>
  );
};

export default ProfileUploadDocument;
